module.exports = __webpack_public_path__ + "img/upload.66ce4bc2.svg";


//////////////////
// WEBPACK FOOTER
// ./public/upload.svg
// module id = znk8
// module chunks = 1